import { render, staticRenderFns } from "./UserUsername.vue?vue&type=template&id=1f2b633c"
import script from "./UserUsername.vue?vue&type=script&lang=js"
export * from "./UserUsername.vue?vue&type=script&lang=js"
import style0 from "./UserUsername.vue?vue&type=style&index=0&id=1f2b633c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports